import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageMenu from "../../../blocks/PageMenu/PageMenu";
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import useDecode from "hooks/useDecode";
import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';
import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import useGetInfoSolicitudPrestacionesEspeciales from "services/record/SolicitudPrestacionesEspeciales/useGetInfoSolicitudPrestacionesEspeciales";
import useGetSolicitudPrestacionesEspecialesByID from "services/record/SolicitudPrestacionesEspeciales/useGetSolicitudPrestacionesEspecialesByID";
import useGetSolicitudPrestacionesEspecialesByUser from "services/record/SolicitudPrestacionesEspeciales/useGetSolicitudPrestacionesEspecialesByUser";
import SolicitudPrestacionesEspeciales from "./SolicitudPrestacionesEspeciales";


const GridSolicitudPrestacionesEspeciales = ({ expedienteId = null, origen = null }) => {

    const {
        getSolicitudPrestacionesEspecialesByID,
        loadingGetSolicitudPrestacionesEspecialesByID,
        statusGetSolicitudPrestacionesEspecialesByID
    } = useGetSolicitudPrestacionesEspecialesByID();

    const {
        getInfoSolicitudPrestacionesEspeciales,
        loadingGetInfoSolicitudPrestacionesEspeciales,
        statusGetInfoSolicitudPrestacionesEspeciales
    } = useGetInfoSolicitudPrestacionesEspeciales();

    const {
        dataGetSolicitudPrestacionesEspecialesByUser,
        getSolicitudPrestacionesEspecialesByUser,
        loadingGetSolicitudPrestacionesEspecialesByUser,
        statusGetSolicitudPrestacionesEspecialesByUser
    } = useGetSolicitudPrestacionesEspecialesByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = "Solicitud de ayuda económico/social a través de la comisión de prestaciones especiales";
    const navigate = useNavigate();
    const location = useLocation();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;

    const origenValue = location?.state?.origen ?? origen ?? null;
    const expedienteIdValue = location?.state?.expedienteId ?? expedienteId ?? null;
    const expedienteIdByOrigen = Number(origenValue) === 1 ? (expedienteIdValue ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    ////////////////////////////////////////
    // Carga inicial
    ////////////////////////////////////////
    useEffect(() => {
        getSolicitudPrestacionesEspecialesByUser(userId, expedienteIdByOrigen);
    }, []);

    ////////////////////////////////////////
    // Unificación HTTP
    ////////////////////////////////////////
    useEffect(() => {
        if (statusGetSolicitudPrestacionesEspecialesByID?.status) {
            setCurrentHttp({
                status: statusGetSolicitudPrestacionesEspecialesByID.status,
                statusText: statusGetSolicitudPrestacionesEspecialesByID.statusText
            });
        } else if (statusGetInfoSolicitudPrestacionesEspeciales?.status) {
            setCurrentHttp({
                status: statusGetInfoSolicitudPrestacionesEspeciales.status,
                statusText: statusGetInfoSolicitudPrestacionesEspeciales.statusText
            });
        } else if (statusGetSolicitudPrestacionesEspecialesByUser?.status) {
            setCurrentHttp({
                status: statusGetSolicitudPrestacionesEspecialesByUser.status,
                statusText: statusGetSolicitudPrestacionesEspecialesByUser.statusText
            });
        }
    }, [
        statusGetSolicitudPrestacionesEspecialesByID,
        statusGetInfoSolicitudPrestacionesEspeciales,
        statusGetSolicitudPrestacionesEspecialesByUser
    ]);

    ////////////////////////////////////////
    // Selección fila
    ////////////////////////////////////////
    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getSolicitudPrestacionesEspecialesByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    ////////////////////////////////////////
    // Generar formulario
    ////////////////////////////////////////
    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoSolicitudPrestacionesEspeciales(userId, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    ////////////////////////////////////////
    // Mostrar botón generar
    ////////////////////////////////////////
    useEffect(() => {
        const arrData = dataGetSolicitudPrestacionesEspecialesByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 99);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetSolicitudPrestacionesEspecialesByUser]);

    ////////////////////////////////////////
    // Loader unificado
    ////////////////////////////////////////
    const isLoading = () => {
        return (
            loadingGetSolicitudPrestacionesEspecialesByID ||
            loadingGetInfoSolicitudPrestacionesEspeciales ||
            (loadingGetSolicitudPrestacionesEspecialesByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetSolicitudPrestacionesEspecialesByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={handleInfo}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {/* SUCCESS */}
            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <SolicitudPrestacionesEspeciales
                        key={`${info ? "create" : "edit"}-${dataUser?.Id ?? "new"}-${formRenderKey}`}
                        dataUser={dataUser}
                        info={info}
                        origen={origenValue}
                        expedienteId={expedienteIdValue}
                        onSuccess={() => getSolicitudPrestacionesEspecialesByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {/* ERROR */}
            {currentHttp.status && !isLoading() && ![200, 204].includes(currentHttp.status) && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridSolicitudPrestacionesEspeciales;